[
  {
    "label": "English",
    "code": "en"
  },
  {
    "label": "Danish",
    "code": "da"
  },
  {
    "label": "German",
    "code": "de"
  },
  {
    "label": "Italian",
    "code": "it"
  },
  {
    "label": "Portuguese",
    "code": "pt"
  },
  {
    "label": "Russian",
    "code": "ru"
  },
  {
    "label": "Spanish",
    "code": "es"
  },
  {
    "label": "Swedish",
    "code": "sv"
  }
]
